import { memo } from "react"
import { Typography, Box } from "@mui/material"
import { useContinueReadingBooks } from "./useContinueReadingBooks"
import { HomeBookList } from "./HomeBookList"

export const ContinueReadingSection = memo(function ContinueReadingSection() {
  const { data: continueReadingBooks } = useContinueReadingBooks()

  return (
    <>
      {continueReadingBooks.length > 0 && (
        <Box>
          <Typography
            variant="h6"
            component="h1"
            sx={{
              padding: 1,
              paddingTop: 2,
            }}
          >
            Continue reading
          </Typography>
          <HomeBookList
            data={continueReadingBooks}
            restoreScrollId="homeScreenContinueReadingBookList"
          />
        </Box>
      )}
    </>
  )
})
